import { render, staticRenderFns } from "./Snake.container.vue?vue&type=template&id=62e0f2ec&scoped=true&"
import script from "./Snake.container.vue?vue&type=script&lang=js&"
export * from "./Snake.container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62e0f2ec",
  null
  
)

export default component.exports